import $, { extend } from 'jquery';
import React from 'react';
import {UserToken,getUserObjData} from '../function_lib/userToken';
import {CallMapMethod,AjaxCallMethod,GetImgCertUser_CBack,RespBkMthdMapp,detectEmojisAndSpecialCharacters,
  CallMapMethod_CBack,btnSetColor_CBack} from '../function_lib/common_lib';
//import { loadCaptchaEnginge, LoadCanvasTemplate, LoadCanvasTemplateNoReload, validateCaptcha } from 'react-simple-captcha';

import {Custom_Alert,Alert_Content} from '../components/custom_alert';
import Header from '../user_pages/header';
import Footer from '../user_pages/footer';



import defaultPic from '../assets/images/user_thumb.png';
import pdfIcon from '../assets/images/pdf_icon.png';
import mp3Icon from '../assets/images/mp3_icon.png';
import mp4Icon from '../assets/images/mp4_icon.png';

let loginUser="";
let userObject="";
let companyName="";
let clsMemberProfile;



//let genderList=["पु.","म.","बा.","बालि."];
let genderList=["M.","F."];
let castCategoryList=["GEN","OBC","SC","ST"];
class Member_Profile extends React.Component{
    constructor(props){
        super(props);
        if(localStorage.getItem("userData")!=null){
          userObject= getUserObjData();
          //alert(JSON.stringify(userObject));
          loginUser=userObject[0].first_name;
          companyName=userObject[0].first_name;
      }
      this.state={stMemberProfile:[]};
      clsMemberProfile=this;
    
      }
      getMemberProfile(status="0"){
        //child component use this method loan_document_upload_comp
        var map=[];
        map.push({name:"curl_type",value:"getMemberProfile"});
        map.push({name:"res_func",value:"callBackrrr"});
        map.push({name:"local_token",value:userObject[0].id});
        map.push({name:"user_type",value:userObject[0].type});
       
      
        
        map["res_func"]="callBackrrr";
        map["curl_type"]="getMemberProfile";
        CallMapMethod_CBack(clsMemberProfile,map,function(data,msg){
        //   alert(data);
        //   return;
            if(data!=="0" && data!==""){
                let listData=JSON.parse(data);
                var strData="";
               // alert(JSON.stringify(listData.receipt_amount));
               clsMemberProfile.setState({ stMemberProfile:listData},()=>{
                
                });
              }
        });
      }

saveWappCompaign(){
 
btnSetColor_CBack(clsMemberProfile,"frmUpdMemberProfile","editMemberProfile",function(checkData,checkMsg){
    //alert(checkData+checkMsg)
    if(checkData===-10){
      alert("Kindly fill required fields");
      return;
    }else if(checkData==="001"){
      Custom_Alert("Updated Successfully",checkMsg,true);
        //window.location.reload();
    }else {
      Custom_Alert("Not Updated",checkMsg,false);
      //alert(checkMsg);
    }
    
  });

  
 
}

 isFloat(n) {
  let checkNum = false;
  if (Number(n)) {
      checkNum = true;
  } else if (n % 1 !== 0) {
      checkNum = true;
  } else {
      checkNum = false;
  }

  return checkNum;
}
okSucc(data,msg){
    if(data==="001"){
alert(msg);
    }else{
        alert("Not updated, kindly contact to support");
    }
    
}
 
componentDidMount(){
    
    this.getMemberProfile();
  AjaxCallMethod(this,"okSuccCNOT");
 
$("#app_user_id").val(userObject[0].id);


}

   render(){
          return(<div>
<Header/>
<div className="content">
<div className="container-fluid mt-4">

<section class="content">
      <div class="container-fluid">
        {this.state.stMemberProfile.length>0?
        <div class="row">
          <div class="col-md-3">

            <div class="card card-primary card-outline">
              <div class="card-body box-profile">
                <div class="text-center">
                  <img class="profile-user-img img-fluid img-circle"
                       src={defaultPic}
                       alt="User profile picture" />
                </div>

                <h3 class="profile-username text-center">{this.state.stMemberProfile[0]["full_name"]}</h3>

                

                <ul class="list-group list-group-unbordered mb-3">
                <li class="list-group-item">
                    <b>Member No</b> <a class="float-right">{this.state.stMemberProfile[0]["mem_no"]}</a>
                  </li>
                  <li class="list-group-item">
                    <b>Email</b> <a class="float-right">{this.state.stMemberProfile[0]["email_addr"]}</a>
                  </li>
                  <li class="list-group-item">
                    <b>Contact No</b> <a class="float-right">{this.state.stMemberProfile[0]["mobile_no"]}</a>
                  </li>
                 
                </ul>

                
              </div>
              
            </div>
            

           
            </div>
            

<div className='col-md-9'>
             {/* <!-- About Me Box --> */}
             <div class="card card-primary">
              <div class="card-header">
                <h3 class="card-title">Update my profile</h3>
              </div>
              {/* <!-- /.card-header --> */}
              <div class="card-body">
              <form class="form-group" id="frmUpdMemberProfile" name="frmUpdMemberProfile" enctype="multipart/form-data" method="POST" onsubmit="event.preventDefault()">
                            <input type="hidden" name="res_func" id="res_func" value="okSucc" />
                            <input type="hidden" name="curl_type" id="curl_type" value="editMemberProfile" />
                            <input type="hidden" name="m_type" id="m_type" value="editMemberProfile" />
                            
                            <input type="hidden" name="local_token" id="local_token" value={userObject[0].id}/>
                            
                          
                            
                            <div class="card-body">
                                <div className="row">
                               
                                <div className="col-lg-4 col-md-4">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Full Name</label>
                                            <div className="input-group input-group-sm">
                                                <input type="text" id="full_name" name="full_name" defaultValue={this.state.stMemberProfile[0]["full_name"]} className="form-control required" placeholder="" />
                                            </div>
                                        </div>
                                  </div>
                                  <div className="col-lg-4 col-md-4">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Forename</label>
                                            <div className="input-group input-group-sm">
                                                <input type="text" id="forename" name="forename" defaultValue={this.state.stMemberProfile[0]["forename"]} className="form-control required" placeholder="" />
                                            </div>
                                        </div>
                                  </div>
                                  <div className="col-lg-4 col-md-4">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Surname</label>
                                            <div className="input-group input-group-sm">
                                                <input type="text" id="surname" name="surname" defaultValue={this.state.stMemberProfile[0]["surname"]} className="form-control required11" placeholder="" />
                                            </div>
                                        </div>
                                  </div>
                                  <div className="col-lg-4 col-md-4">
                             <div className="form-group">
                                            <label for="exampleInputEmail1">Email</label>
                                            <div className="input-group input-group-sm">
                                                <input type="text" id="email_addr" name="email_addr" defaultValue={this.state.stMemberProfile[0]["email_addr"]} className="form-control required" placeholder="" />
                                            </div>
                                        </div>
                          </div>

                          <div className="col-lg-4 col-md-4">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Mobile No.</label>
                                            <div className="input-group input-group-sm">
                                                <input type="text" id="mobile_no" name="mobile_no" defaultValue={this.state.stMemberProfile[0]["mobile_no"]} className="form-control required" placeholder="" />
                                            </div>
                                        </div>
                                  </div>
                                  <div className="col-lg-4 col-md-4">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Branch Name</label>
                                            <div className="input-group input-group-sm">
                                                <input type="text" id="branch_name" name="branch_name" defaultValue={this.state.stMemberProfile[0]["branch_name"]} className="form-control required11" placeholder="" />
                                            </div>
                                        </div>
                                  </div>

                                  <div className="col-lg-4 col-md-4">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Grade</label>
                                            <div className="input-group input-group-sm">
                                                <input type="text" id="grade" name="grade" defaultValue={this.state.stMemberProfile[0]["grade"]} className="form-control required11" placeholder="" />
                                            </div>
                                        </div>
                                  </div>


                                </div>

                                
                                
  {/* other details  */}
          
        
                            {/* end of other details */}                           

                                <div className="col-md-6 respSSL"></div>
                                <div id="testing2dd2222"></div>
                                <div class="row">
                                    <div class="col-12">
                                      
                                        <div class="form-group">
                                        <center>
                                            <div class="input-group input-group-sm" style={{"justify-content":"right"}}>
                                                <button type="button" onClick={()=>this.saveWappCompaign()} class="btn btn-danger">Update Profile</button>
                                            </div>
                                        </center>
                                        </div>
                                        
                                    </div>
                                </div>
                                </div>
                            </form>

              
              </div>

            </div>  
          </div>

          </div>
         :''}
          </div>
          </section>

</div>
</div>
<Alert_Content/>
<Footer/>

          </div>)
      }
}
export default Member_Profile;